var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 8.74984V5.6665C14.6666 4.26637 14.6666 3.56631 14.3941 3.03153C14.1544 2.56112 13.772 2.17867 13.3016 1.93899C12.7668 1.6665 12.0667 1.6665 10.6666 1.6665H5.33325C3.93312 1.6665 3.23306 1.6665 2.69828 1.93899C2.22787 2.17867 1.84542 2.56112 1.60574 3.03153C1.33325 3.56631 1.33325 4.26637 1.33325 5.6665V14.3332C1.33325 15.7333 1.33325 16.4334 1.60574 16.9681C1.84542 17.4386 2.22787 17.821 2.69828 18.0607C3.23306 18.3332 3.93312 18.3332 5.33325 18.3332H7.99992M9.66659 9.1665H4.66659M6.33325 12.4998H4.66659M11.3333 5.83317H4.66659M12.9999 17.4998V12.4998M10.4999 14.9998H15.4999",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingopIcon);
export default __webpack_public_path__ + "static/media/billingopIcon.402b94559ded3241dd57d73788bfd1b5.svg";
export { ForwardRef as ReactComponent };